import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters/educational-content.adapter';
import { ErrorMessagesMocks } from '../../mocks/error-messages.mocks';
import {
  EDUCATIONAL_PAGE_FEATURE_KEY,
  State,
  educationalContentAdapter
} from '../reducers/educational-content.reducer';

// Lookup the 'Education Content' feature state managed by NgRx
const getEducationalPageState = createFeatureSelector<State>(
  EDUCATIONAL_PAGE_FEATURE_KEY
);

const { selectEntities } = educationalContentAdapter.getSelectors();

const getEducationalPageEntities = createSelector(
  getEducationalPageState,
  (state: State) => selectEntities(state)
);

export const getEducationalContent = createSelector(
  getEducationalPageEntities,
  (entities) =>
    Adapters.getEducationalContent(
      entities['aem-educational-content']?.aemContent,
      entities['aem-educational-content-error']?.aemContentError,
      ErrorMessagesMocks
    )
);
